import type { SlateBlock } from '@atlas/renderer';
import { Editor, Transforms, Node, Path, Element, Text } from 'slate';
import matchNode from '@atlas/tool/box/slate/matchNode';
import areSamePoints from '@atlas/tool/box/slate/areSamePoints';
import getNode from '@atlas/tool/box/slate/getNode';

export default function removeLink(editor: Editor, node?: Node) {
    if (node) {
        const path = findNodePath(editor, node);
        if (!path.length) return false;

        Transforms.setNodes(editor, { link: null }, { at: path });
        return true;
    }

    if (!editor.selection) return false;

    const matchedNode = matchNode(editor, function matchNodesWithLinkAttribute(node) {
        return 'link' in node && typeof node.link === 'string'; // Text with link mark or image with link attribute
    });
    if (matchedNode) {
        Transforms.setNodes(editor, { link: null }, { match: (node) => node === matchedNode });
        return true;
    }

    // If cursor is at the beginning of Leaf and it has previous leaf, test if previous leaf is a link and remove it
    if (editor.selection.focus.offset === 0 && areSamePoints(editor.selection.anchor, editor.selection.focus)) {
        const leafIndex = editor.selection.focus.path.slice(-1)[0];
        if (leafIndex > 0) {
            const prevNodePath = editor.selection.focus.path.slice(0, -1).concat(leafIndex - 1);
            const previousNode = getNode(editor, prevNodePath);
            if (Text.isText(previousNode) && 'link' in previousNode && typeof previousNode.link === 'string') {
                Transforms.setNodes(editor, { link: null }, { at: prevNodePath });
                return true;
            }
        }
    }

    return false;
}

// #region Helpers

function findNodePath(editorOrNode: Editor | SlateBlock, node: Node): Path {
    for (let i = 0; i < editorOrNode.children.length; i++) {
        if (editorOrNode.children[i] === node) return [i];
        if (Element.isElement(editorOrNode.children[i])) {
            const nestedResult = findNodePath(editorOrNode.children[i] as SlateBlock, node);
            if (nestedResult.length) return [i].concat(nestedResult);
        }
    }
    return [];
}

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('removeLink', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
